<template>
  <div class="b1">
    <div class="bg"></div>
    <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
    <div class="body">
      <div class="center">
        <div class="c_input">
          <div>名字</div>
          <input placeholder="请输入" v-model="studentName" />
        </div>
        <el-button type="primary" size="small" plain @click="search">搜索</el-button>
        <el-button size="small" plain @click="reset">重置</el-button>
      </div>
      <div class="bottom">
        <el-table :header-cell-style="{ background: '#F7F8FA' }" :data="list" style="width: 100%;" :height="'100%'">
          <el-table-column prop="stuNo" label="学号"></el-table-column>
          <el-table-column label="头像">
            <template slot-scope="scope">
              <img style="width: 40px;height: 40px;border-radius: 8px;" :src="webImg + scope.row.avatar">
            </template>
          </el-table-column>
          <el-table-column prop="stuName" label="学生姓名"></el-table-column>
          <!-- <el-table-column prop="gender" label="性别"></el-table-column> -->
          <!-- <el-table-column prop="className" label="所属班级"></el-table-column> -->
          <el-table-column prop="dailyRecordTotal" label="记录数量"></el-table-column>
          <el-table-column prop="lastEntryTime" label="最后记录时间" width="200">
            <template slot-scope="scope">
              <div>{{ scope.row.lastEntryTime?getDateTime2(scope.row.lastEntryTime) : '' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="primary" size="small" plain
                @click="$router.push({ path: '/archivesList', query: { studentId: scope.row.studentId } })">查看记录</el-button>
              <!-- <el-button type="warning" size="small" plain @click="btn_edit(scope.$index)">修改</el-button> -->
              <!-- <el-button type="danger" size="small" plain @click="btn_del(scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="list.length">
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
import {
  dailyRecordListStudent,
  classInfo
} from '@/apis/index'
export default {
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      classId: this.$route.query.id || '',
      info: {},
      studentName:''
    }
  },
  mounted() {
    this.getClassInfo()
    this.getList()
  },
  methods: {
    search(){
      this.getList()
    },
    reset(){
      this.studentName = ''
      this.getList()
    },
    getList() {
      dailyRecordListStudent(this.classId,this.studentName).then(res => {
        console.log(res, 'dailyRecordListStudent');
        this.list = res.data
      })
    },
    getClassInfo() {
      classInfo(this.classId).then(res => {
        console.log(res, 'classInfo');
        this.info = res.data
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.pageNum = 1
      // this.pageSize = val
      // this.getList()
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      // this.pageNum = val
      // this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
.line1_ {
  word-break: break-all;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.line2_ {
  word-break: break-all;
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.b1 {
  width: 100%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;

  .bg {
    width: 100%;
    height: 228px;
    background: linear-gradient(180deg, #F3F5FA 0%, #FFFFFF 100%);
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
}

.back {
  width: 1200px;
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  // margin-bottom: 10px;
  margin-top: 10px;
  cursor: pointer;
  box-sizing: border-box;

  img {
    width: 14px;
    height: 14px;

  }
}

.body {
  width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 20px;

  .center {
    width: 100%;
    display: flex;
    align-items: center;
    margin: 40px 0;

    .c_input {
      display: flex;
      align-items: center;

      div {
        font-weight: 400;
        font-size: 12px;
        color: #333333;
      }

      input {
        margin-left: 20px;
        width: 280px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #CED4DB;
        box-sizing: border-box;
        padding: 0 12px;
        margin-right: 20px;
      }
    }
  }

  .bottom {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  }
}
</style>
